import React, { useState, useEffect } from "react";
// import "./massage.scss";
import { Modal, Form, Button } from "react-bootstrap";
import { CustomInput } from "../../kits/Inputs/Inputs";
import SendMassage from "../../customer-list/customerModal/SendMassage";
import { Spinner } from "react-bootstrap";

export default function MassagePreview({
  show,
  setShow,
  files,
  setFiles,
  setText,
  text,
  adminMsg,
  setAdminMsg,
  sendHandler,
  spinnerStatus = false,
  adminMsgFlag = true,
}) {
  const handleClose = () => setShow(false);

  const SendMassage = () => {
    const fileListArr = Array.from(files);
    setFiles(fileListArr);
    sendHandler(fileListArr, text);
  };

  // This function will be triggered when the "Remove This Image" button is clicked
  const removeSelectedImage = (name) => {
    // as an array, u have more freedom to transform the file list using array functions.
    const fileListArr = Array.from(files);
    fileListArr.splice(name, 1); // here u remove the file

    if (fileListArr.length == 0) {
      handleClose();
    }
    setFiles(fileListArr);
  };
  useEffect(() => {
    if (show == false) setFiles([]);
  }, [show]);
  useEffect(() => {}, [files.length]);
  return (
    <div className="massage">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>ارسال پیام</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
            className=" container"
          >
            {files.length > 0 &&
              Object.keys(files).map((keyName, i) => (
                <div
                  key={i}
                  style={{
                    marginTop: 50,
                    display: "flex",
                    flexDirection: "column",
                  }}
                  className="preview"
                >
                  <img
                    src={URL.createObjectURL(files[keyName])}
                    className="image"
                    style={{ maxWidth: "100%", maxHeight: 320 }}
                  />
                  <button
                    style={{
                      cursor: "pointer",
                      padding: 15,
                      background: "red",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => {
                      removeSelectedImage(keyName);
                    }}
                    className="delete"
                  >
                    لغو
                  </button>
                </div>
              ))}
            <CustomInput
              placeholder={"متن"}
              inputType="textarea"
              type="text"
              inputValue={text}
              onChangeFunc={(e) => {
                setText(e.target.value);
              }}
              labelClassName="text-dark"
              inputContainer="w-100 mt-4"
            />
            {adminMsgFlag && (
              <Form.Check
                checked={adminMsg}
                onChange={(e) => {
                  setAdminMsg(e.target.checked);
                }}
                className="mt-3"
                type={"checkbox"}
                id={"admin_not"}
                label={"پیام مخصوص ادمین است"}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            لغو
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              SendMassage();
            }}
          >
            {spinnerStatus && (
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                variant="light"
              />
            )}{" "}
            ارسال
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
